const { CrudModel } = require('./crud');

export class AccountReceivableModel extends CrudModel {
	constructor() {
		super('admin/account_receivable', []);
	}

	async importCsv(csv: string) {
		return this.executeAction(null, "importCsv", { csv });
	}
}

export default new AccountReceivableModel();
